import { render, staticRenderFns } from "./GlobalReport.vue?vue&type=template&id=e5293a72"
import script from "./GlobalReport.vue?vue&type=script&lang=js"
export * from "./GlobalReport.vue?vue&type=script&lang=js"
import style0 from "./GlobalReport.vue?vue&type=style&index=0&id=e5293a72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports